import React from "react";

const CardFileList = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-6">Card Files</h1>
      <div className="bg-white shadow-md rounded-md p-6">
        <p className="text-gray-500">No card files found. This is a placeholder component.</p>
      </div>
    </div>
  );
};

export default CardFileList;
